import React, { useRef, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HomeContainer from '../main/HomeContainer';
import OverlayContainer from '../ui/OverlayContainer';
import ConfirmEmailContainer from '../../containers/users/ConfirmEmailContainer';
import HelpContainer from '../../containers/main/HelpContainer';
import About from '../../components/utilities/About';
import TermsContainer from '../../containers/main/TermsContainer';
import PrivacyContainer from '../../containers/main/PrivacyContainer';
import LoginContainer from '../../containers/users/LoginContainer';
import CallbackSSOContainer from '../../containers/users/CallbackSSOContainer';
import CallbackPepsiSSOContainer from '../../containers/users/CallbackPepsiSSOContainer'

function AuthorizationEverybody(props) {
    let navigate = useNavigate();
    let [timeoutMark, setTimeoutMark] = useState(null);
    let [showDeny, setShowDeny] = useState(false);
    let [allowedRoles] = useState(['Viewer', 'Builder', 'ClientAdmin', 'IEAdmin', 'guest']);
    let superRef = useRef(null);

    // trigger on component mount
    useEffect(() => {
        lagRender();
        handleLoginRedirect();
    });

    function lagRender() {
        if (timeoutMark === null && !showDeny) {
            let timeout = setTimeout(flipDeny, 4000);
            setTimeoutMark({ timeout });
        }
    }

    function flipDeny() {
        if (superRef.current !== null) {
            clearTimeout(timeoutMark);
            setShowDeny(true);
            setTimeoutMark(null);
        }
    }

    function handleLoginRedirect() {
        //If user isn't logged in, store the current path and send them to the login screen to be redirected back to once they log in.
        if (!allowedRoles.includes(props.role) && !props.loading && !props.popup && showDeny) {
            const location = {
                pathname: '/',
                state: {
                    from: { pathname: props.location.pathname }
                }
            }
            navigate(location);
        }            
    }

    function renderMainPage() {
        switch(props.toRender) {
            case 'home':
                return <HomeContainer />;
            case 'confirmemail':
                return <ConfirmEmailContainer />;
            case 'help':
                return <HelpContainer />;
            case 'about':
                return <About />;
            case 'terms':
                return <TermsContainer />;
            case 'privacy':
                return <PrivacyContainer />;
            case 'login':
                return <LoginContainer />;
            case 'login-microsoft':
                return <CallbackSSOContainer />;
            case 'login-pepsi':
                return <CallbackPepsiSSOContainer />;
            default:
                return false;
        }
    }
    
    if (allowedRoles.includes(props.role) && !props.loading && !props.popup) {
        return <div className="main" ref={superRef}>{renderMainPage()}</div>;
    } else if (props.loading || props.popup) {
        return (
            <div className="main" ref={superRef}>
                <OverlayContainer {...props} />
                {renderMainPage()}
            </div>
        );
    } else {
        return (showDeny) ? <p ref={superRef} style={{'marginLeft': '100px', 'marginTop': '100px', 'fontSize':"30px"}}>There was an error trying to access this page</p> : null
    }
}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        loading: state.ui.loading,
        loadingMessage: state.ui.loadingMessage,
        popup: state.ui.popup,
    }
}

export default connect(mapStateToProps, null)(AuthorizationEverybody);